<template>
  <section id="app">
    <!-- header -->
    <section class="header">
      <img
        class="banner"
        src="~assets/images/banner.jpg"
        alt=""
        >
    </section>

    <!-- border -->
    <section class="border">
      <img
        class="butterfly"
        src="~assets/images/butterfly.png"
        alt=""
        >
    </section>

    <!-- loading -->
    <m-loading v-show="loading"></m-loading>

    <!-- main -->
    <section
      class="main"
      v-show="!loading"
      >
      <!--抢购-->
      <section class="production">
        <section
          v-for="(production, index) in productions"
          :class="`item item-${index + 1}`"
          >
          <img
            class="logo"
            :src="prodctionLogos[index]"
            alt=""
            >
          <p class="title">
            <span class="white">{{production.name}}</sppan>
            <!--<span class="green">1个月</span><span class="white">优惠</span>-->
          </p>
          <p class="price">￥{{production.salePrice | money}}</p>
          <p class="origin">原价￥{{production.originalPrice | money}}</p>
          <a
            class="button button_primary"
            @click="buyProduction(production)"
            >
            立即抢购
            <i class="icon icon-arrow"/>
          </a>
        </section>
      </section>

      <!-- 功能介绍 -->
      <section class="core">
        <section class="title-container">
          <p class="title">
          核心功能
          </p>
          <p class="subtitle">
            一站式解决店铺管理难题
          </p>
        </section>

        <!-- 核心功能 -->
        <section class="function-container flex-container">
          <section class="flex-item">
            <img class="logo" src="~assets/images/function-logo-1.png" alt="">
            <p class="name">收银</p>
          </section>

          <section class="flex-item">
            <img class="logo" src="~assets/images/function-logo-2.png" alt="">
            <p class="name">会员管理</p>
          </section>

          <section class="flex-item">
            <img class="logo" src="~assets/images/function-logo-3.png" alt="">
            <p class="name">员工业绩</p>
          </section>

          <section class="flex-item">
            <img class="logo" src="~assets/images/function-logo-4.png" alt="">
            <p class="name">经营数据</p>
          </section>
        </section>

        <!-- 手机图片 -->
        <section class="mobile-container">
          <!-- 彩带背景 -->
          <img class="bg" src="~assets/images/bg.png" alt="">

          <section class="mobile-row">
            <img class="logo" src="~assets/images/mobile-1.png" alt="">
            <img class="logo" src="~assets/images/mobile-2.png" alt="">
          </section>

          <section class="mobile-row">
            <img class="logo" src="~assets/images/mobile-3.png" alt="">
            <img class="logo" src="~assets/images/mobile-4.png" alt="">
          </section>
        </section>

        <!-- 购买 -->
        <section class="buy-container">
          <p class="title">即将上线功能</p>

          <section class="function flex-container">
            <section class="flex-item">
              <img class="logo" src="~assets/images/buy-logo-1.png" alt="">
              <p class="name">微营销</p>
            </section>

            <section class="flex-item">
              <img class="logo" src="~assets/images/buy-logo-2.png" alt="">
              <p class="name">预约</p>
            </section>
          </section>

          <section class="button-container">
            <a
              @click="goAnchor()"
              class="button button_primary"
              >
              立即购买
            </a>
          </section>
        </section>

      </section>

      <!-- footer -->
      <section class="footer">
        <p class="tip">还没有下载店务通？</p>
        <p class="download">AppStore、应用宝等应用商城下载</p>
        <p class="link">
          或点击链接
          <a
            href="//mjb8.cn/00UH"
            >
            http://mjb8.cn/00UH
          </a>
        </p>
      </section>
    </section>

    <!-- dialog -->
    <transition
      name="fade"
      v-if="showDialog"
      >
      <section class="dialog-warpper">
        <!-- overlay -->
        <section
          class="dialog-overlay"
          @click="closeDialog()"
          >
        </section>

        <!-- container -->
        <section class="dialog-container">
          <!-- close -->
          <a
            class="dialog-close"
            @click="closeDialog()"
            >
            <i class="icon icon-close"></i>
          </a>

          <!-- content -->
          <section class="dialog-header">
            请输入您登录店务通的手机号 <br>
            没有注册过的用户可先购买，购买后用这个 <br>
            手机号注册登录店务通即可
          </section>

          <section class="dialog-body">
            <section class="form-row">
              <input
                class="form-input"
                type="tel"
                placeholder="请输入手机号"
                v-model="tel"
                />
              <a
                class="form-ext button_primary"
                :class="{'is-disabled': verifyCodeDisabled}"
                @click="getVerifyCode()"
                >
                {{verifyCodeText}}
              </a>
            </section>

            <section class="form-row">
              <input
                class="form-input"
                type="tel"
                placeholder="请输入验证码"
                v-model="verifyCode"
                />
            </section>

            <a
              class="form-button button_primary"
              :class="{'is-disabled': telDisabled, 'is-loading': submiting}"
              @click="login()"
              >
              {{telText}}
            </a>
          </section>

        </section>
      </section>
    </transition>
  </section>
</template>

<script>

import api from 'api'
import store from 'store'

import loading from 'components/loading'

export default {
  name: 'Index',

  components: {
    mLoading: loading,
  },

  data() {
    return {
      // 手机号 验证码
      tel: null,
      verifyCode: null,
      verifyCodeTimer: null,
      verifyCodeTimeLeft: 60,

      // 产品
      production: null,
      productions: [],
      prodctionLogos: [
        require('../assets/images/production-1.png'),
        require('../assets/images/production-2.png'),
        require('../assets/images/production-3.png'),
      ],

      // 弹窗
      showDialog: false,

      // 状态
      submiting: false,
      loading: true,
    }
  },

  computed: {
    verifyCodeDisabled() {
      if (this.verifyCodeTimer) {
        return true
      }

      return !/^1[3|4|5|7|8][0-9]{9}$/.test(this.tel)
    },

    verifyCodeText() {
      return this.verifyCodeTimer ? `${this.verifyCodeTimeLeft}秒后重发` : '获取验证码'
    },

    telDisabled() {
      return !/^1[3|4|5|7|8][0-9]{9}$/.test(this.tel) || !this.verifyCode
    },

    telText() {
      return this.submiting ? '提交中...' : '开始验证'
    },
  },

  methods: {
    buyProduction(production) {
      this.production = production
      this.showDialog = true
    },

    getVerifyCode() {
      const resetTimer = () => {
        clearInterval(this.verifyCodeTimer)
        this.verifyCodeTimer = null
        this.verifyCodeTimeLeft = 60
      }

      const countDown = () => {
        this.verifyCodeTimer = setTimeout(() => {
          this.verifyCodeTimeLeft = this.verifyCodeTimeLeft - 1

          if (this.verifyCodeTimeLeft > 0) {
            countDown()
          } else {
            resetTimer()
          }
        }, 1000)
      }

      // 开始倒计时
      resetTimer()
      countDown()

      api.get('/user/sendVerifyCode', {
        params: {
          tel: this.tel,
          type: 3,
        },
      })
      .then(() => {
        // 验证码发送成功
      })
      .catch((error) => {
        resetTimer()
        alert(error.errMsg || '获取验证码失败')
      })
    },

    login() {
      this.submiting = true

      api.get('/user/superLogin', {
        params: {
          type: 3,
          tel: this.tel,
          verifyCode: this.verifyCode,
        },
      })
      .then(({data}) => {
        store.token = data.token
        store.tel = this.tel

        const shops = data.shopBriefVOs || []
        const shop = shops[0]
        store.shop = shop

        // 重新获取产品列表 + 获取支付方式列表
        return Promise.all([
          api.get('/subscribe/productList', {
            params: {
              token: data.token,
              tel: this.tel,
              shopId: shop ? shop.id : null,
            },
          }),
          api.get('/subscribe/payChannelList'),
        ])
      })
      .then((result) => {
        const productions = result[0].data || []
        const payments = result[1].data || []

        const pruduction = productions.filter((item) => {
          return item.id === this.production.id && item.buyNumLimit > 0
        })[0]

        if (!pruduction) {
          alert(`很抱歉\n${this.production.name}每店限用1个，该手机号码已购买过，请选择其他套餐～`)
          this.submiting = false
        }

        store.payments = payments
        store.production = pruduction

        this.$router.push('pay')
        this.submiting = false
      })
      .catch((error) => {
        alert(error.errMsg || '验证失败')
        this.submiting = false
      })
    },

    closeDialog() {
      this.showDialog = false
    },

    goAnchor() {
      // mode hash下无法跳转到锚点
      document.body.scrollTop = 0
    },
  },

  created() {
    api
      .get('/subscribe/productList')
      .then(({data}) => {
        this.productions = data.slice(0, 3)

        this.loading = false
      })
      .catch((error) => {
        console.log(error)
      })
  },
}

</script>

<style lang="scss" scoped>
.header {
  img.banner {
    display: block;
    width: 100%;
  }
}

.border {
  background-image: url(~assets/images/less.jpg);
  background-repeat: repeat-x;
  background-size: contain;
  position: relative;
  height: 25px;

  img.butterfly {
    position: absolute;
    width: 56px;
    left: 50%;
    top: -6px;
    margin-left: -28px;
    z-index: 99;
  }
}


@media only screen and (max-device-width: 320px) {
  .production {
    padding: 0 6px 10px 6px;

    .item {
      margin-left: 4px;
    }
  }
}

.production {
  background-color: #fff;
  padding-bottom: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  padding: 0px 16px 10px 16px;

  .item {
    flex: 1;
    border-radius: 6px;
    margin-left: 8px;
    padding: 19px 0 9px 0;
    text-align: center;
    position: relative;

    &:first-child {
      margin-left: 0px;
    }

    &.item-1 {
      background-color: #ffd0d6;
    }
    &.item-2 {
      background-color: #CEDBFB;
    }
    &.item-3 {
      background-color: #B6E1EA;
    }

    .title {
      position: absolute;
      width: 100%;
      left: 0;
      top: 31px;
      font-size: 12px;
      margin: 0;

      .green {
        color: #4BC596;
      }

      .yellow {
        color: #FFFF00;
      }

      .white {
        color: #fff;
      }

      .blue {
        color: #0076FF;
      }
    }

    img.logo {
      width: 66px;
    }

    .price {
      font-size: 16px;
      color: #FF519F;
      margin-top: 2px;
      margin-bottom: 0;
    }

    .origin {
      font-size: 10px;
      color: #C4C4C4;
      margin-top: 2px;
      margin-bottom: 0;
      text-decoration: line-through;
    }

    .button {
      display: inline-block;
      border-radius: 10px;
      height: 20px;
      line-height: 20px;
      font-size: 10px;
      margin-top: 2px;
    }
  }
}

.core {
  background-color: #fff;
  text-align: center;
  margin-top: 5px;
  overflow: hidden;

  .flex-container {
    display: flex;
    justify-content: center;

    .flex-item {
      margin-left: 27px;
      /*width: 54px;*/
      text-align: center;

      &:first-child {
        margin-left: 0;
      }

      img.logo {
        width: 54px;
        height: 54px;
      }

      .name {
        font-size: 14px;
        color: #992929;
        margin-top: 7px;
        margin-bottom: 0;
      }
    }
  }

  .title-container {
    padding-top: 23px;

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #262626;
      margin: 0;
    }

    .subtitle {
      font-size: 14px;
      color: #262626;
      margin-top: 7px;
      margin-bottom: 0;
    }
  }

  .function-container {
    margin-top: 26px;
  }

  .mobile-container {
    margin-top: 30px;
    position: relative;

    .bg {
      position: absolute;
      top: -30px;
      left: 0;
      width: 100%;
      z-index: 0;
    }

    .mobile-row {
      display: flex;
      justify-content: center;
      margin-top: 15px;
      position: relative;
      z-index: 1;

      &:first-child {
        margin-top: 0;
      }

      .logo {
        margin-left: 20px;
        width: 103px;
        height: 215px;
        position: relative;
        z-index: 1;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  .buy-container {
    margin-top: 49px;
    text-align: center;
    position: relative;
    z-index: 1;

    .title {
      font-size: 18px;
      color: #262626;
    }

    .function {
      margin-top: 25px;
    }

    .button-container {
      margin-top: 35px;
      padding: 0 38px;

      a.button {
        display: block;
        width: 100%;
      }
    }
  }
}

.footer {
  padding-top: 26px;
  padding-bottom: 28px;
  background-color: #fff;
  text-align: center;
  position: relative;
  z-index: 1;

  .tip {
    font-size: 14px;
    color: #262626;
    margin: 0;
  }

  .download {
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    margin-top: 14px;
    margin-bottom: 0;
  }

  .link {
    font-size: 12px;
    color: #262626;
    margin-top: 6px;
    margin-bottom: 0;

    a {
      font-size: 14px;
      color: #FF519F;
    }
  }
}

/* dialog */
.dialog-overlay {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow: auto;
  z-index: 2017;

  background-color: #858585;
  opacity: 0.49;
}

.dialog-container {
  position: fixed;
  width: 80%;
  max-width: 300px;
  top: 50%;
  left: 50%;
  padding: 20px 16px;
  transform: translate(-50%, -50%);
  background-color: #FFFFFF;
  text-align: center;
  border-radius: 10px;
  overflow: hidden;
  z-index: 2018;

  .dialog-close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px; /*加大点击区域*/
    text-align: right; 
    z-index: 2019;
  }

  .dialog-header {
    font-size: 12px;
    color: #030303;
    line-height: 16px;
    margin-bottom: 22px;
    text-align: center;
    position: relative;
  }

  .dialog-body {
    .form-row {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .form-input {
        appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        color: #1f2d3d;
        display: block;
        width: 100%;
        height: 36px;
        line-height: 1;
        outline: none;
        padding: 3px 10px;

        flex: 1;
      }

      .form-ext {
        display: block;
        margin-left: 5px;
      }

      a.form-ext {
        min-width: 80px;
        height: 36px;
        line-height: 36px;
        padding: 0;
        font-size: 12px;
      }
    }
  }
}

.icon-arrow {
  background-image: url('~assets/images/icon-arrow.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 4px;
  height: 7px;
}

.icon-close {
  background-image: url('~assets/images/icon-close.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 10px;
  height: 10px;
}

</style>


// WEBPACK FOOTER //
// Index.vue?1fd91b3d